import type { Surface } from '@deckspace/types';
import { SurfaceRenderer, ContentErrorBoundary } from '@deckspace/ui';
import type { SSEConnectionStatus } from '@deckspace/client';
import { WorkspaceEmpty } from './WorkspaceEmpty';

export interface PageRendererProps {
  surface: Surface | null;
  workspaceId: string;
  connectionStatus: SSEConnectionStatus;
  themeKey?: number;
  onUpdateNodeProps?: (surfaceId: string, nodeId: string, props: Record<string, unknown>) => void;
}

export function PageRenderer({
  surface,
  workspaceId,
  connectionStatus,
  themeKey,
  onUpdateNodeProps,
}: PageRendererProps) {
  if (!surface) {
    return <WorkspaceEmpty variant="no-surface" connectionStatus={connectionStatus} />;
  }
  return (
    <ContentErrorBoundary
      key={surface.id}
      title="Surface Error"
      message="Something went wrong rendering this surface."
    >
      <SurfaceRenderer
        components={surface.components}
        workspaceId={workspaceId}
        themeKey={themeKey}
        onComponentPropsChange={(nodeId, props) => onUpdateNodeProps?.(surface.id, nodeId, props)}
      />
    </ContentErrorBoundary>
  );
}
